import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { store, persistor } from "./store";
import { AuthProvider } from "./context/AuthContext";
import { GlobalLoaderProvider } from './context/GlobalLoaderContext';
import { GOOGLE_CLIENT_ID } from "./config/oauth";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./index.css";

// GoogleOAuthProvider crashes with an empty clientId. Use a placeholder so
// the app still renders; clicking the button will show a config error instead.
const googleClientId = GOOGLE_CLIENT_ID || 'not-configured';

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={googleClientId}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <AuthProvider>
                <GlobalLoaderProvider>
                  <App />
                </GlobalLoaderProvider>
              </AuthProvider>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
